import { render, staticRenderFns } from "./HomeBannerKV.vue?vue&type=template&id=4b0dbd64&scoped=true"
import script from "./HomeBannerKV.vue?vue&type=script&lang=js"
export * from "./HomeBannerKV.vue?vue&type=script&lang=js"
import style0 from "./HomeBannerKV.vue?vue&type=style&index=0&id=4b0dbd64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0dbd64",
  null
  
)

export default component.exports